
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 2400 1006.667"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1515.267 247.736h-80.12V695.83a6768.104 6768.104 0 01217.533 10.994v-78.946a6864.694 6864.694 0 00-137.413-7.768zm636.733.045h-88.013l-58.014 134.468-52.12-134.468h-86.693l93.16 240.276-101.693 235.719a6665.556 6665.556 0 0184.213 8.765l59.147-137.054 58.573 151.082c30.507 3.923 60.933 8.016 91.307 12.351l.133-.052-104.373-269.188zm-991.884 444.132l80.124-.017V509.624h108.613v-78.945H1240.24V327.44h143.547v-79.656h-223.671zM860.917 327.436h83.858v369.17a6929.062 6929.062 0 0180.121-2.535V327.436h83.853v-79.655H860.917zm-273.92 392.116a6743.075 6743.075 0 01222.558-16.533v-78.955a6883.616 6883.616 0 00-142.436 9.733V514.276c31.062-.31 71.965-1.257 108.201-.807v-78.952c-28.95-.07-75.477.404-108.201.823V327.441h142.436v-79.656H586.997zM429.83 537.042l-104.353-289.26H249.33V758.93a6803.385 6803.385 0 0180.122-10.914v-277.96l92.788 266.548c29.184-3.384 58.42-6.59 87.713-9.603v-479.22H429.83zm1288.904 174.534a6509.884 6509.884 0 0180.134 6.616v-470.41h-80.134v463.794","fill":"#ed1c24"}})])
          )
        }
      }
    